import React, { Fragment, useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import Fade from "react-reveal/Fade";
import SectionWrapper, { Container } from "./googleReviews.style";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

const GoogleReviews = () => {
  const [loading, setLoading] = useState(true);
  const [testimonialData, setTestimonialData] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://radianceadmin.manageprojects.in/api/testimonials"
        );
        const result = await response.json();
        if (result.success) {
          setTestimonialData(result.data);
          setReviews(result.data.testimonials[0]?.reviews || []);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Helper function to safely parse rating
  const getValidRating = (rating) => {
    const num = parseInt(rating);
    return isNaN(num) ? 5 : Math.min(Math.max(num, 1), 5);
  };

  // Helper function to render stars
  const renderStars = (rating) => {
    const validRating = getValidRating(rating);
    return (
      <>
        {[...Array(validRating)].map((_, i) => (
          <FontAwesomeIcon key={i} icon={faStar} style={{ color: "#D87B1C" }} />
        ))}
      </>
    );
  };

  const allGoogleReviews = reviews.map((review, index) => ({
    id: index,
    title: review.user_name || "Anonymous",
    firstlatter: review.user_name?.charAt(0) || "A",
    description: <div dangerouslySetInnerHTML={{ __html: review.review_text }} />,
    date: review.date || "",
    rating: review.user_rating || "5"
  }));

  return (
    <SectionWrapper id="googleReviews">
      <Container className="myContainer">
        <div className="row">
          <div className="col-md-4">
            <Fade top>
              <img
                className="greviewimg showmob"
                width="404"
                height="434"
                src="/service-images/Reviewss.jpg"
                alt="google reviews"
                style={{ marginTop: "10px" }}
              />
            </Fade>
            <Fade left>
              <img
                className="greviewimg hidemob"
                width="404"
                height="434"
                src={testimonialData?.testimonials[0]?.review_img || "/home/review.webp"}
                alt="Customer testimonials and Google reviews"
                loading="lazy"
                style={{ marginTop: "10px" }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/home/review.webp"; // Fallback to local image
                }}
              />
            </Fade>
          </div>
          <div className="col-md-8">
            <div className="reviewFold" style={{ display: "block" }}>
              <div className="flex">
                <Fade left>
                  <div className="leftGarea">
                    <h3 className="title">
                      {testimonialData?.testimonials[0]?.page_heading ||
                        "Highest Number of Google Rating in Delhi-NCR in This Segment"}
                    </h3>
                    <p className="subheadstar">
                      {renderStars(5)}
                      <span>
                        {testimonialData?.testimonials[0]?.total_rating ||
                          "4.9 Rating of 2000+ Reviews"}
                      </span>
                    </p>
                  </div>
                </Fade>
                <Fade right>
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=Google&query_place_id=ChIJc5hFOhUDDTkR84Qd5N0PQ58"
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-default btn-lg black"
                    style={{ marginLeft: "auto" }}
                  >
                    Write a Review
                  </a>
                </Fade>
              </div>
              <div className="divider" style={{ margin: "15px auto" }}></div>
              <Fade bottom>
                <div className="swiperOverfloww" style={{ marginBottom: "60px" }}>
                  <div className="flex gReviewsIcos">
                    <div className="swiper-button-prevG">
                      <FontAwesomeIcon icon={faArrowLeft} />
                    </div>
                    <div className="swiper-button-nextG">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                  </div>
                  <Swiper
                    spaceBetween={30}
                    slidesPerView={2}
                    navigation={{
                      prevEl: ".swiper-button-prevG",
                      nextEl: ".swiper-button-nextG",
                    }}
                    breakpoints={{
                      300: { slidesPerView: 1 },
                      768: { slidesPerView: 2 },
                    }}
                  >
                    {allGoogleReviews.map((review) => (
                      <SwiperSlide key={review.id}>
                        <div className="gCard">
                          <div className="gHead">
                            <p className="mb-0">{review.firstlatter}</p>
                          </div>
                          <p className="reviewPara">
                            <img
                              loading="lazy"
                              width="111"
                              height="111"
                              src="/home/quote.svg"
                              alt={`Review from ${review.title}`}
                            />
                            {review.description}
                          </p>
                          <div className="gFooter">
                            <div className="gHeadContent">
                              {renderStars(review.rating)}
                              <h5>{review.title}</h5>
                              <p>{review.date}</p>
                            </div>
                            <img
                              width="68"
                              height="68"
                              src="/google.png"
                              alt="Google logo"
                            />
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </Container>
    </SectionWrapper>
  );
};

export default GoogleReviews;